import React, { ReactNode } from "react";
import styles from './OrderSteps.module.scss'

/**
 * Numbered steps in a tinted panel, optionally with a footer (e.g. buttons) inside the panel
 */
export default ({steps, footer, className}: { steps: ReactNode[], footer?: ReactNode, className?: string }) =>
  <div className={[styles.panel, className].filter(Boolean).join(' ')}>
    <ol className={styles.steps}>
      {steps.map((step, index) => <li key={index} className={styles.step}>
        <span className={styles.number} aria-hidden>{index + 1}</span>
        <span>{step}</span>
      </li>)}
    </ol>
    {footer && <div className={styles.footer}>{footer}</div>}
  </div>
